import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class B2bAbroadIncomeComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/abroad-income';
  }

  public static regex(): RegExp {
    return /\/statement\/\d+\/abroad-income((\/?#?)|(\/?#.*?))$/;
  }
}
